import { Weekday } from '@/domain/dienstplan/shared/types/Weekday';
import { t } from 'i18next';

/* eslint-disable complexity */
export function getLocaleWeekdayString(weekday: Weekday) {
  if (weekday === 'montag') {
    return t('general.date.days.monday');
  }
  if (weekday === 'dienstag') {
    return t('general.date.days.tuesday');
  }
  if (weekday === 'mittwoch') {
    return t('general.date.days.wednesday');
  }
  if (weekday === 'donnerstag') {
    return t('general.date.days.thursday');
  }
  if (weekday === 'freitag') {
    return t('general.date.days.friday');
  }
  if (weekday === 'samstag') {
    return t('general.date.days.saturday');
  }
  if (weekday === 'sonntag') {
    return t('general.date.days.sunday');
  }
  if (weekday === 'feiertag') {
    return t('general.date.days.holiday');
  }
}
